/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * vCenter component information
 */
export interface VcenterComponentInfo { 
    /**
     * vCenter version
     */
    version?: string;
    /**
     * Flag indicating whether vDefend is enabled
     */
    isVdefendEnabled?: boolean;
    /**
     * Associated site identifier
     */
    siteId?: string;
}

